import { faAngleLeft, faAngleRight, faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@sharedComponents/Typography';

import * as style from './style.module.css';

const Card = ({ number, isSelected = false, onClick = () => {} }) => {
    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
            className={`${style.card} ${isSelected ? style.selected : style.basic} ${number === '...' ? style.dots : ''}`}
            onClick={onClick}
            onKeyDown={(e) => e.key === 'Enter' && onClick?.()}
            role="button"
            tabIndex={0}
        >
            <Typography>{number}</Typography>
        </div>
    );
};

const getCardsToDisplay = (totalPages, currentPage) => {
    if (totalPages <= 1) return [1];
    if (totalPages <= 5) return Array.from({ length: totalPages }, (_, i) => i + 1);

    let visiblePages = new Set();

    // conditions when first is selected because it has to display 5 cards in every cases
    if ([1, 2, totalPages - 1, totalPages].includes(currentPage)) {
        if (currentPage === 1) {
            visiblePages = new Set([1, 2, 3, totalPages - 1, totalPages]);
        } else if (currentPage === totalPages) {
            visiblePages = new Set([1, 2, totalPages - 2, totalPages - 1, totalPages]);
        } else {
            visiblePages = new Set([1, 2, totalPages - 1, totalPages]);
        }
    } else {
        visiblePages = new Set([1, currentPage, totalPages]);
    }

    if (currentPage > 1) visiblePages.add(currentPage - 1);
    if (currentPage < totalPages) visiblePages.add(currentPage + 1);

    const sortedPages = [...visiblePages].sort((a, b) => a - b);
    const result = [];

    for (let i = 0; i < sortedPages.length; i++) {
        if (i > 0 && sortedPages[i] !== sortedPages[i - 1] + 1) {
            result.push('...');
        }
        result.push(sortedPages[i]);
    }

    return result;
};

const Pagination = ({ totalPages = 1, selectedPage = 1, onChange = () => {} }) => {
    const cardsToDisplay = getCardsToDisplay(totalPages, selectedPage);

    const handlePrevious = () => {
        if (selectedPage > 1) onChange(selectedPage - 1);
    };

    const handleNext = () => {
        if (selectedPage < totalPages) onChange(selectedPage + 1);
    };

    return (
        <div className={style.container}>
            {totalPages > 1 && <FontAwesomeIcon className={style.icon} icon={faAngleLeft} onClick={handlePrevious} />}
            {cardsToDisplay.map((i, index) =>
                i === '...' ? (
                    <FontAwesomeIcon className={style.dots} key={`page-${index}`} icon={faEllipsis} />
                ) : (
                    <Card key={`page-${index}`} number={i} isSelected={i === selectedPage} onClick={() => onChange(i)} />
                ),
            )}
            {totalPages > 1 && (
                <div className={style.iconContainer}>
                    <FontAwesomeIcon className={style.icon} icon={faAngleRight} onClick={handleNext} />
                </div>
            )}
        </div>
    );
};

export default Pagination;
